<!--
Author: TangChen
Date: 2018-11-06
Desc: CRS信息，由index.js 配置引入
-->
<template>
    <div :class="'view-con-info view bg-white ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/orginfo' }">
                    信息中心
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>
        <crs-info />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import crsInfo from "@/components/acctInfo/conInfo.vue";
export default {
    name: "TaxesInfo",
    components: {
        crsInfo
    },
    mixins: [mixin],
    data () {
        return {
        };
    },
    methods: {
    }
};
</script>
